module.exports = __webpack_public_path__ + "media/images/member-database-2-95787c3930c781fcc2c119ad9051071c.svg";